<div class="close-tab">

  <div class="field date-chips">
    <div class="label">Available Expirations</div>
    <div class="chips">
      <!-- CR-20260831-004: .param-changed on the SELECTED chips = the date set differs from the
           run's. Selected chips paint, because the diff is over the SET — it cannot name which
           single toggle restores it. -->
      <div class="chip"
           *ngFor="let d of this.dateItems"
           [class.selected]="this.isDateSelected(d.value)"
           [class.param-changed]="this.isDateSelected(d.value) && this.isChanged('dates')"
           (click)="this.toggleDate(d.value)">
        {{ d.label }}
      </div>
      <div class="empty" *ngIf="this.dateItems.length === 0">No Expirations in the Book.</div>
    </div>
  </div>

  <div class="field">
    <div class="label">Target</div>
    <dx-button-group
      [class.param-changed]="this.isChanged('target.kind')"
      [items]="this.targetKindButtons"
      keyExpr="id"
      selectionMode="single"
      stylingMode="contained"
      [selectedItemKeys]="[this.targetKind]"
      [disabled]="!this.hasSelectedDates"
      (onItemClick)="this.onTargetKind($event)"
    ></dx-button-group>
    <div class="hint all-hint" *ngIf="this.targetKind === 'all'">{{ this.targetHint }}</div>
  </div>

  <div class="field hedge-list" *ngIf="this.targetKind === 'hedges'">

    <div class="hedge-group" *ngIf="this.callHedges.length > 0">
      <div class="group-divider"><span>CALLS</span></div>
      <div class="hedge-item" *ngFor="let h of this.callHedges">
        <dx-check-box
          [class.param-changed]="this.isHedgeSelected(h.id) && this.isChanged('target.hedges')"
          [value]="this.isHedgeSelected(h.id)"
          [text]="h.label"
          [disabled]="h.previewed"
          (onValueChanged)="this.onHedgeToggle(h.id, $event.value)"
        ></dx-check-box>
      </div>
    </div>

    <div class="hedge-group" *ngIf="this.putHedges.length > 0">
      <div class="group-divider"><span>PUTS</span></div>
      <div class="hedge-item" *ngFor="let h of this.putHedges">
        <dx-check-box
          [class.param-changed]="this.isHedgeSelected(h.id) && this.isChanged('target.hedges')"
          [value]="this.isHedgeSelected(h.id)"
          [text]="h.label"
          [disabled]="h.previewed"
          (onValueChanged)="this.onHedgeToggle(h.id, $event.value)"
        ></dx-check-box>
      </div>
    </div>

  </div>

</div>
